import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { Score, ScoreText } from '@web/components/survey/surveyScore/SurveyScoreStep.styles';

type Props = {
  score: number;
  setScore: (score: number) => void;
};

const SurveyScores = ({ score, setScore }: Props) => {
  return (
    <>
      {new Array(5).fill(true).map((_, i) => (
        <Score key={`${i}`} isSet={score === i + 1} onClick={(): void => setScore(i + 1)}>
          <ScoreText
            themeColor={score === i + 1 ? ThemeColorType.primary : ThemeColorType.primaryText}>
            {i + 1}
          </ScoreText>
        </Score>
      ))}
    </>
  );
};

export default SurveyScores;
